import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getEvent = createAsyncThunk(
	"program/event",
	async ({ eventID }) => {
		const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
		const REACT_APP_ENV = process.env.REACT_APP_ENV;
		const REACT_APP_API_URL_TEST = process.env.REACT_APP_API_URL_TEST;

		try {
			const url =
				REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;

			const response = await axios({
				method: "get",
				url: `${url}/api/event/public/${eventID}`,
				headers: {
					"Content-Type": "application/json",
				},
			});
			return response?.data;
		} catch (error) {
			throw new Error("Bir Hata Oluştu: Event Api Error");
		}
	}
);

const initialState = {
	error: null,
	loading: null,
	event: null,
};

export const eventSlice = createSlice({
	name: "event",
	initialState,
	reducers: {
		emptySpeaker: (state) => {
			state.speaker = null;
		},
	},
	extraReducers: (builder) => {
		builder

			// evenet detaylarını getirme
			.addCase(getEvent.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(getEvent.fulfilled, (state, action) => {
				state.loading = false;
				state.error = null;
				state.event = action.payload;
			})
			.addCase(getEvent.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
			});
	},
});

export const { emptySpeaker } = eventSlice.actions;
export default eventSlice.reducer;
